import { colors } from 'theme'

export const defaultThemeStyles = {
    borderMain: colors.white,
    borders: colors.selected,
    'inv-borderMain': colors.selected,
    'inv-borders': colors.white,
}
